export default "__VITE_ASSET__db9c0d17__"